/**
 * Percent-input helpers for the platform-config pages.
 *
 * Display formatting (dates, ratios as percents) comes from the app's shared
 * formatter, utils/display-format.ts, so a date or a threshold reads the same
 * way on these pages as on every other operator page. What lives here is the
 * editing half: the ratios these pages edit are stored as decimals (0.80) and
 * edited as a whole percent ("80"). An empty field is an absence, not a zero.
 */

/**
 * A decimal ratio (0.8) as the editable percent string "80" (at most two
 * decimals, no trailing zeros). An absent ratio edits as an empty field.
 */
export function ratioToPercentInput(ratio: number | null | undefined): string {
  if (typeof ratio !== 'number' || !Number.isFinite(ratio)) return '';
  return String(Math.round(ratio * 10000) / 100);
}

/**
 * The editable percent string "80" back to the ratio 0.8. An empty or
 * non-numeric field returns null: it is not a zero.
 */
export function percentInputToRatio(value: string): number | null {
  if (value.trim() === '') return null;
  const parsed = Number(value);
  if (!Number.isFinite(parsed)) return null;
  return Math.round(parsed * 100) / 10000;
}
